import urljoin from 'url-join';
import ky from './kyInstance';

import { BASE_PATH } from '..';

export const getSliderSlides = async () => {
  return ky.get(urljoin(BASE_PATH, 'public', 'homepage', 'slider'));
};
